import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import './cancelation.scss'
import { StandardCancellation } from './StandardCancellation'; 
import usePageTitle from '../../../Hooks/usePageTitle';
import useBodyClass from '../../../Hooks/useBodyClass';
import { RetentionOffer} from './RetentionOffer';
import { ConfirmCancellation } from './ConfirmCancellation';
import { RetentionOfferAcceptance } from './RetentionOfferAcceptance';
import { SubscriberCampaignCancellation } from './SubscriptionCampaignCancellation';
import CancelationRrasons from './CancelationReasons';
import { useParams } from 'react-router';
import { APIPost } from '../../API/APIRequest';
import { Loading } from '../../Utilities/Loading';
import { GenericErrorBox } from '../../UI/ErrorBox/GenericErrorBox';
import { useSearchParams } from 'react-router-dom';


export function Cancelation(props, errorStates) {
    const { t, i18n } = useTranslation();
    const [subscriberCampaignExists, setSubscriberCampaignExists] = useState(false);
    const [isLoading, setIsLoading] = useState(true)
    const [campaignData, setCampaignData] = useState({});
    const [errors, setErrors] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const {brandingElement} = props;
    const { fid } = useParams();
    useBodyClass(['cancelation', props.brandingElement?.bodyClass]);
    usePageTitle(`Cancellation -  ${props.brandingElement?.id}`);

    const storeSubscriptionPageUrl = ()=>{
      
            let mySubsUrl = searchParams.get("returnUrl");
            sessionStorage.setItem("subsPageUrl", mySubsUrl)
    }

    const getApplicableCampaignDetails = () => {
        
        APIPost({

            "controller": "order",
            "action": "applicablecampaigndetail",
            "data": { "fid": fid},
            "content_type": "json"

        })
            .then((response) => {
            
                console.log(response?.data);
                let data= response?.data?.campaignData;
                setSubscriberCampaignExists(data?.isCampaignApplied)
                setCampaignData(data);
                setIsLoading(false);

            }).catch((error) => {
            
               var unexpected = [];
               unexpected.push("error.unexpected");
               setErrors(unexpected);
               console.log("An error occured while cancelling the subscription")
               setIsLoading(false);
            })
    }

    useEffect(()=>{
        
        storeSubscriptionPageUrl();
  
        getApplicableCampaignDetails();
       
      }, [])

      const termsText = brandingElement?.termsText || '';

    return (
        <div className="container-wrapper">

           {(errors?.length > 0) ? <GenericErrorBox errors={errors} /> 
            : isLoading ? <Loading loading = {isLoading} />  : subscriberCampaignExists ? <SubscriberCampaignCancellation campaignData={campaignData} termsText={termsText} setErrors={setErrors}/> : <StandardCancellation showCancellationForm={campaignData?.showCancellationForm} setErrors={setErrors}/>}

        </div>
            );
} 